/* eslint-disable react/require-default-props */
import { Trans, t } from '@lingui/macro';
import classnames from 'classnames';
import PropTypes from "prop-types";
import React from "react";

const styledTags = (source) => {
  switch (source) {
    case 'user': case null: case 'null': case undefined:
      return null;
    case 'hiveml:logos':
      return 'hv-ml-tag';
    case 'people_tagging':
      return 'ppl-tag';
    default:
      return 'auto-generated';
  }
}

const hiveAltText = () => t({ comment: 'Company name', message: `Hive` });

const AssetTags = ({ orgSearchPage, tags }) => (
  <div className="s-tag-section">
    <h3 className="s-asset-details-title modal-label">
      <Trans>Tags</Trans>
    </h3>
    {tags.some((t) => t.source === 'hiveml:logos') &&
      <span className="hv-ml-title">
        <Trans>
          Highlighted Tags Powered By
          <a href={`https://thehive.ai/`} target={"_blank"}>
            <img alt={hiveAltText} src="https://cdn.bfldr.com/27C9EC93/at/j4vghz6vw9qcghbkzrmxns/hive-logo.svg">
            </img>
          </a>
        </Trans>
      </span>
    }
    {tags.map((tag) => {
      if (orgSearchPage) {
        const orgSlug = window.location.pathname
          .split("organizations/")[1]
          .split("/search")[0];

        const { name, source } = tag.attributes;

        return (
          <a
            key={`tag-${source}-${name}`}
            href={`/organizations/${orgSlug}/search?q=tags:"${encodeURI(name)}"`}
          >
            <span
              className={classnames('s-show-tags', 'j-main', styledTags(source))}
            >
              {name}
            </span>
          </a>
        );
      }

      const { name, source } = tag;

      if (BFG.showPageLite) { // tags not clickable in share link asset modal
        return (
          <span
            key={`tag-${source}-${name}`}
            className={
              classnames('s-show-tags', 'j-main', styledTags(source), 'share-link-tags')
            }
          >
            {name}
          </span>
        );
      }

      return (
        <button
          key={`tag-${source}-${name}`}
          className={classnames('s-show-tags', 'j-main', styledTags(source))}
          onClick={() => {
            // Track tag click with Amplitude
            if (window.BFG?.amplitude?.enabled && window.amplitudeService) {
              window.amplitudeService.trackEvent('TagNameLink-ButtonClicked', {
                elementName: 'TagName',
                productArea: 'SearchAndDiscovery',
                featureArea: 'BrandfolderView',
                'key properties': {
                  tagName: name
                }
              });
            }
            BF.dialog.dismiss();
            BF.fx.fillInAndFilterQuery(
              `tags.strict:"${name.replace('"', '\\"')}"`
            );
          }}
          type="button"
        >
          {name}
        </button>
      );
    })}
  </div>
);

AssetTags.propTypes = {
  orgSearchPage: PropTypes.bool,
  tags: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    source: PropTypes.string, // TODO: restrict to supported sources
  })).isRequired,
};

AssetTags.defaultProps = {
  orgSearchPage: false,
};

export default AssetTags;
